import type { DirectoryFilters } from '@/components/client/directory/use-directory-reducer'

import type { DirectoryRelease } from './aggregate-releases'
import { hasProductFilters, pickBestDirectoryProduct, productsMatchingFilters } from './filter-release-products'

export const pickCompareSlug = (release: DirectoryRelease, filters: DirectoryFilters): string => {
  const { products } = release

  if (hasProductFilters(filters)) {
    const matchingProducts = productsMatchingFilters(products, filters)
    if (matchingProducts.length === 1) {
      return matchingProducts[0].slug
    }
    if (matchingProducts.length > 1) {
      return pickBestDirectoryProduct(matchingProducts).slug
    }
  }

  // No filters or no matches: pick best from all products
  return pickBestDirectoryProduct(products).slug
}
